module.exports = __webpack_public_path__ + "img/partners-top-xs-drawing-2.6c40ce1b.svg";